import { render, staticRenderFns } from "./CommonPeronOrgColumn.vue?vue&type=template&id=b52b065c&"
import script from "./CommonPeronOrgColumn.vue?vue&type=script&lang=js&"
export * from "./CommonPeronOrgColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports